import type { RemoteDisplayState } from '../../../domain/RemoteDisplayState.ts';

/** Верхняя полоса letterbox + разделители (fruit-ninja + target-attack). */
export function drawHudStrip(
  ctx: CanvasRenderingContext2D,
  state: Pick<RemoteDisplayState, 'remoteView'>,
  W: number,
): void {
  const stripH = state.remoteView?.offsetY ?? 0;
  if (stripH <= 0) return;

  ctx.save();
  const bg = ctx.createLinearGradient(0, 0, 0, stripH);
  bg.addColorStop(0, 'rgba(0,0,0,0.80)');
  bg.addColorStop(1, 'rgba(0,0,0,0.45)');
  ctx.fillStyle = bg;
  ctx.fillRect(0, 0, W, stripH);
  ctx.restore();

  ctx.save();
  ctx.beginPath();
  ctx.moveTo(0, stripH);
  ctx.lineTo(W, stripH);
  ctx.strokeStyle = 'rgba(255,255,255,0.55)';
  ctx.lineWidth = 2;
  ctx.shadowBlur = 12;
  ctx.shadowColor = 'rgba(255,220,100,0.7)';
  ctx.stroke();
  ctx.restore();

  const pad = stripH * 0.18;
  ctx.save();
  ctx.strokeStyle = 'rgba(255,255,255,0.18)';
  ctx.lineWidth = 1;
  ctx.setLineDash([6, 8]);
  ctx.shadowBlur = 0;
  for (const x of [W / 3, (2 * W) / 3]) {
    ctx.beginPath();
    ctx.moveTo(x, pad);
    ctx.lineTo(x, stripH - pad);
    ctx.stroke();
  }
  ctx.setLineDash([]);
  ctx.restore();
}

export function drawSideStrips(
  ctx: CanvasRenderingContext2D,
  state: Pick<RemoteDisplayState, 'remoteView'>,
  H: number,
  canvasWidth: number,
): void {
  const ox = state.remoteView?.offsetX ?? 0;
  if (ox <= 0) return;
  const gameRight = ox + (state.remoteView?.gameWidth ?? 0);
  const W = canvasWidth;

  ctx.save();
  const leftBg = ctx.createLinearGradient(0, 0, ox, 0);
  leftBg.addColorStop(0, 'rgba(0,0,0,0.80)');
  leftBg.addColorStop(1, 'rgba(0,0,0,0.45)');
  ctx.fillStyle = leftBg;
  ctx.fillRect(0, 0, ox, H);
  ctx.restore();

  const rightW = W - gameRight;
  ctx.save();
  const rightBg = ctx.createLinearGradient(gameRight, 0, W, 0);
  rightBg.addColorStop(0, 'rgba(0,0,0,0.45)');
  rightBg.addColorStop(1, 'rgba(0,0,0,0.80)');
  ctx.fillStyle = rightBg;
  ctx.fillRect(gameRight, 0, rightW, H);
  ctx.restore();

  ctx.save();
  ctx.strokeStyle = 'rgba(255,255,255,0.55)';
  ctx.lineWidth = 2;
  ctx.shadowBlur = 12;
  ctx.shadowColor = 'rgba(255,220,100,0.7)';
  for (const x of [ox, gameRight]) {
    ctx.beginPath();
    ctx.moveTo(x, 0);
    ctx.lineTo(x, H);
    ctx.stroke();
  }
  ctx.restore();

  const pad = ox * 0.18;
  ctx.save();
  ctx.strokeStyle = 'rgba(255,255,255,0.18)';
  ctx.lineWidth = 1;
  ctx.setLineDash([6, 8]);
  ctx.shadowBlur = 0;
  for (const y of [H / 3, (2 * H) / 3]) {
    ctx.beginPath();
    ctx.moveTo(pad, y);
    ctx.lineTo(ox - pad, y);
    ctx.stroke();
    ctx.beginPath();
    ctx.moveTo(gameRight + pad, y);
    ctx.lineTo(W - pad, y);
    ctx.stroke();
  }
  ctx.setLineDash([]);
  ctx.restore();
}
